module.exports = __webpack_public_path__ + "img/camera.60cb895c.png";